import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        cursor: 'pointer' as const,
        padding: '.5rem 1rem',
        textDecoration: 'inherit',
        '&:hover': {
            backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
                '#F3F3F3'
        }
    },
    primaryText: {
        fontSize: '1.1rem',
        lineHeight: '1.3rem'
    },
    secondaryText: {
        fontSize: '.8rem',
        lineHeight: '.9rem',
        color: theme?.app?.applicationColors.fontDetailColor ||
            '#4A4C50',
        marginBottom: '.25rem'
    },
    userName: {
        fontWeight: 'bold' as const,
        color: theme?.app?.applicationColors.fontDetailColor ||
            '#4A4C50'
    },
    firmName: {
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        marginBottom: '.5rem'
    },
    walletsLabel: {
        color: theme?.app?.applicationColors.fontDetailColor ||
            '#4A4C50',
        fontWeight: 'bold' as const,
        marginBottom: '.25rem'
    },
    walletNameContainer: {
        marginBottom: '1rem',
        '&:last-child': { marginBottom: 0 }
    },
    walletNameText: {
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073'
    },
    divider: {
        margin: '.75rem 0 1rem 0',
        height: '1px'
    }
});